var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "city-entire-box" }, [
    _c("p", {
      staticClass: "city-type-letter",
      domProps: { textContent: _vm._s(_vm.letter) }
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "city-letter-list" },
      _vm._l(_vm.lists, function(list) {
        return _c(
          "div",
          {
            staticClass: "city-letter",
            on: {
              click: function($event) {
                return _vm.selectCity(list.ShortName, list.Name)
              }
            }
          },
          [_c("span", { domProps: { textContent: _vm._s(list.Name) } })]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-c56bd782", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-c56bd782","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/cityLetterList.vue
// module id = null
// module chunks = 